<template>
    <div>
        <breadcrumbs
            :title="'Umanjeni sati'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Umanjeni sat: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <umanjeni-sat-forma
                    :disabled="true"
                    :id="id"
                    :modal="false"
                    :action="'show'"
                    @returnData="setData"
                ></umanjeni-sat-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import UmanjeniSatForma from "./UmanjeniSatForma";
export default {
    name: "UmanjeniSatDetails",
    components: {
        UmanjeniSatForma,
        Breadcrumbs
    },
    data(){
        return {
            id: this.$route.params.umanjeni_sat_id,
            breadcrumbs: [],
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/umanjeni-sati',
                    name: 'Umanjeni sati'
                },
                {
                    path: '/postavke/umanjeni-sati/' + this.id,
                    name: 'Umanjeni sat: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv || ''
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
